import { TrustReconciliationLayout } from './layouts';
import { TrustHistoryView } from './components/TrustHistoryView';

export function TrustHistoryPage() {
  return (
    <TrustReconciliationLayout>
      <TrustHistoryView />
    </TrustReconciliationLayout>
  );
}

